import axios from 'axios';
import { getIsApiPending } from '../../../selectors/travelUg/payloadCollection';
import { apiTransitionPayloadCollection } from '../../../actions/travelUg/payloadCollection';
import { getAccessToken } from '../../../selectors/travelUg/payments';
import {
    getAlternatePremiumCalculation,
    getCustomerIdValue,
    getPremiumCalculation,
    getQuoteForm,
} from '../../../selectors/travelUg/quote';
import { getNextOfKinForm } from '../../../selectors/travelUg/nextOfKin';
import { setNextOfKinSubmitted } from '../../../actions/travelUg/nextOfKin';
import { setShowTaggingErrorModal, setTaggingErrorMessage } from '../../../actions/travelUg/quote';
import { collectLoginDetails } from '../../../actions/travelUg/auth';
import { navigateToPayment } from '../../../actions/travelUg/routing';

export const submitNextOfKinService = async (store, next, action) => {
    if (getIsApiPending(store.getState())) {
        return next(action);
    }
    store.dispatch(setShowTaggingErrorModal(false));
    store.dispatch(setTaggingErrorMessage(null));
    store.dispatch(apiTransitionPayloadCollection.pending());

    try {
        await makeSubmission(store.getState());
        store.dispatch(setNextOfKinSubmitted(true));

        store.dispatch(navigateToPayment());
    } catch (error) {
        console.error(error);
        store.dispatch(setNextOfKinSubmitted(false));

        const status = error?.response?.status;

        if (status === 401) {
            store.dispatch(collectLoginDetails());
        }

        store.dispatch(setTaggingErrorMessage('Something went wrong. Try again later'));
        store.dispatch(setShowTaggingErrorModal(true));
    } finally {
        store.dispatch(apiTransitionPayloadCollection.initial());
    }

    return next(action);
};

const getUserQuoteIdentification = (premiumCalc, alternatePremiumCalc, selectedCover) => {
    if (typeof selectedCover.value !== 'string') return '[]';
    return JSON.stringify(
        selectedCover.value.includes('Elite')
            ? alternatePremiumCalc.value?.quote_id || []
            : premiumCalc.value?.quote_id || []
    );
};

const payloadCollection = (state) => {
    const quotation = getQuoteForm(state);
    const nextOfKin = getNextOfKinForm(state);
    const customerId = getCustomerIdValue(state);
    const premiumCalc = getPremiumCalculation(state);
    const alternatePremiumCalc = getAlternatePremiumCalculation(state);

    return {
        id: customerId.value,
        quoteIdentification: getUserQuoteIdentification(premiumCalc, alternatePremiumCalc, quotation.selectedCover),
        nextOfKinFullName: nextOfKin.firstName?.value || 'N/A',
        nextOfKinPhoneNumber: nextOfKin.phoneNumber?.value || 'N/A',
        nextOfKinEmail: nextOfKin.email?.value || 'N/A',
        nextOfKinOfficeNumber: 'N/A',
        nextOfKinAddress: nextOfKin.postalAddress?.value || 'N/A',
        nextOfKinTown: 'N/A',
        nextOfKinRelationship: nextOfKin.relationship?.value || 'N/A',
    };
};

const makeSubmission = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/travel-ug/submit/next-of-kin';
        return await axios.post(url, payloadCollection(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
